import { defineComponent as _defineComponent } from 'vue'
import { ref } from "@nuxtjs/composition-api";
import * as yup from "yup";


export default /*#__PURE__*/_defineComponent({
  __name: 'SignUpCreatePassword',
  emits: ['onContinue'],
  setup(__props, { emit: $emit }) {



const formData = ref({
    password: '',
    passwordConfirm: '',
})
const isPasswordValid = ref(false);
const isSubmitted = ref(false);

const schema = yup.object().shape({
    password: yup
        .string()
        .required('please_enter_your_password'),
    passwordConfirm: yup
        .string()
        .oneOf([yup.ref('password'), null], 'passwords_do_not_match')
        .required('please_confirm_your_password'),
});
const errors = ref<{ [key: string]: string | null }>({ password: null, passwordConfirm: null });

const validateField = async (field: string) => {
    try {
        await schema.validateAt(field, {
            password: formData.value.password,
            passwordConfirm: formData.value.passwordConfirm,
        });
        errors.value[field] = null;
    } catch (error) {
        errors.value[field] = error.message;
    }
};

const handleInputType = (field: string) => {
    validateField(field);

    if (field === 'password' && formData.value.passwordConfirm) {
        validateField('passwordConfirm');
    }

    if (field === 'passwordConfirm' && formData.value.password) {
        validateField('password');
    }
}

const submitForm = () => {
    isSubmitted.value = true;

    schema.validate(
        {
            password: formData.value.password,
            passwordConfirm: formData.value.passwordConfirm,
        },
        { abortEarly: false }
    ).then(() => {
        if (isPasswordValid.value) {
            $emit('onContinue', { password: formData.value.password });
        }
    }).catch(error => {
        if (error.inner) {
            error.inner.forEach((err: yup.ValidationError) => {
                errors.value[err.path] = err.message;
            });
        }
    })
}

return { __sfc: true,$emit, formData, isPasswordValid, isSubmitted, schema, errors, validateField, handleInputType, submitForm }
}

})